(function () {
  'use strict';

  class HeroMediaCarousel {
    constructor(el) {
      this.el = el;
      this.track = el.querySelector('.hero-media__track');
      this.slides = el.querySelectorAll('.hero-media__slide');
      this.dots = el.querySelectorAll('.hero-media__dot');
      this.prevBtn = el.querySelector('.hero-media__nav--prev');
      this.nextBtn = el.querySelector('.hero-media__nav--next');
      this.current = 0;
      this.total = this.slides.length;
      this.autoplayInterval = null;
      this.autoplayDelay = parseInt(el.dataset.autoplay, 10) || 0;
      this.touchStartX = 0;
      this.touchEndX = 0;
      this.isDragging = false;

      if (this.total <= 1) return;

      this.bindEvents();
      this.startAutoplay();
    }

    bindEvents() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.goTo(this.current - 1));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.goTo(this.current + 1));
      }

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.goTo(i));
      });

      // Touch/swipe support
      this.track.addEventListener('touchstart', (e) => this.onTouchStart(e), { passive: true });
      this.track.addEventListener('touchmove', (e) => this.onTouchMove(e), { passive: true });
      this.track.addEventListener('touchend', (e) => this.onTouchEnd(e));

      // Pause autoplay on hover
      this.el.addEventListener('mouseenter', () => this.stopAutoplay());
      this.el.addEventListener('mouseleave', () => this.startAutoplay());

      // Pause when not visible
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.stopAutoplay();
        } else {
          this.startAutoplay();
        }
      });
    }

    goTo(index) {
      if (index < 0) index = this.total - 1;
      if (index >= this.total) index = 0;

      this.current = index;
      this.track.style.transform = `translateX(-${index * 100}%)`;

      this.dots.forEach((dot, i) => {
        dot.classList.toggle('hero-media__dot--active', i === index);
      });

      // Pause all videos, play current if it's a video slide
      this.slides.forEach((slide, i) => {
        const video = slide.querySelector('video');
        if (video) {
          if (i === index) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        }
      });

      this.resetAutoplay();
    }

    onTouchStart(e) {
      this.touchStartX = e.changedTouches[0].screenX;
      this.isDragging = true;
      this.stopAutoplay();
    }

    onTouchMove(e) {
      if (!this.isDragging) return;
      this.touchEndX = e.changedTouches[0].screenX;
    }

    onTouchEnd() {
      if (!this.isDragging) return;
      this.isDragging = false;

      const diff = this.touchStartX - this.touchEndX;
      const threshold = 50;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          this.goTo(this.current + 1);
        } else {
          this.goTo(this.current - 1);
        }
      }

      this.startAutoplay();
    }

    startAutoplay() {
      if (this.autoplayDelay <= 0 || this.total <= 1) return;
      this.stopAutoplay();
      this.autoplayInterval = setInterval(() => {
        this.goTo(this.current + 1);
      }, this.autoplayDelay);
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }

    resetAutoplay() {
      if (this.autoplayDelay > 0) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }
  }

  // Initialize all hero-media carousels
  function init() {
    document.querySelectorAll('.hero-media').forEach((el) => {
      new HeroMediaCarousel(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
